import { get } from '@ln/core/pwa/ajax';
import ConfigProvider from '../Core/Configuration/ConfigProvider';

const ApiContenidosService = {
    GetRankingSitio(quantity = 3) {
        return new Promise(resolve => {
            get(ConfigProvider.ApiContenidosRankingSitioUrl)
                .then(response => {
                    resolve(JSON.parse(response).items.slice(0, quantity));
                });
        });
    },
    GetNotasByCategoria(categoriaId, quantity = 3) {
        return new Promise(resolve => {
            get(`${ConfigProvider.ApiContenidosUltimasNotasUrl}/${categoriaId}`)
                .then(response => {
                    //console.log(response);
                    resolve(JSON.parse(response).items.filter(e => e.imagenes.length !== 0).slice(0, quantity));
                });
        });
    }
};

export default ApiContenidosService;


// WEBPACK FOOTER //
// ./Statics/scripts/Services/ApiContenidosService.js